<p>
  required-user-activity-view works!
</p>
